

import React, { useEffect, useState } from "react";
import AnimatedContent from "../common/AnimatedContent";
import PageTitle from "../common/PageTitle";
import UserTable from "../Components/user/UserTable";
import { RoleList } from "../Enum/RoleList";
import { Button } from "@windmill/react-ui";
import UserForm from "../Components/user/UserForm";
import Drawer from "../common/Drawer";
import { RiHistoryLine } from "react-icons/ri";
import { TbReplace } from "react-icons/tb";
import CustomSearch from "../common/CustomSearch";
import { BiEdit } from "react-icons/bi";
import { FaRegCalendarCheck } from "react-icons/fa6";
import Model from "../common/Model";
import Loading from "../common/Loading";
import useEvents from "../hooks/useEvents";
import EventForm from "../Components/events/EventForm";
import EventTable from "../Components/events/EventTable";
import { handleGetRoleBasedUsers } from "../services/userService";
import { RiTimerLine } from "react-icons/ri";
import ListModel from "../common/ListModel";
import MeetingHistory from "../Components/meetingInfo/MeetingHistory";
import EventHistory from "../Components/events/EventHistory";

const EventList = () => {


    const [visibleHistory, setVisibleHistory] = useState(false);
    const [meetingId, setMeetingId] = useState();
   const [ presonData , setPresonData ] = useState([]);
  const {
    user,
    loading,
    register,
    handleSubmit,
    errors,
    watch,

    handleUserManage,
    exiting,
    setExiting,
    handleExitingData,

    handleToggle,
    handleSearchSubmit,
    setSearchKey,

    limit,

    currentPage,

    nextId,
    prevId,
    handlePageChange,
    handlePageSize,
    handleStatus,
    openStatus,
    setOpenStatus,
    handleDeactiveUser,
    userResignCount,
    loading2,
    hasMore,
    setSelectedAssistant,
  selectedAssistant,

  setSelectedMeeting,
  selectedMeeting,
  setIsListModelOpen,
  isListModelOpen,
  setSelectedId,
  selectedId,

  handleReassign,
    loader,
presonList,
setPersonList,
visible,
setVisible

  } = useEvents();



    

  const columns = [
    {
      key: "name",
      title: "Event Heading",
      render: (text) => (
        <div title={text} className=" text-center truncate">
          {text.replace(/\b\w/g, (char) => char.toUpperCase())}
        </div>
      ),
    },
    {
      key: "dateOut",
      title: "Date",
      render: (text) => (
        <div className="bg-green-50 mx-auto flex items-center justify-center gap-2 text-xs border border-green-500 rounded-full p-1 w-max text-center">
          <FaRegCalendarCheck className="text-primary" />
            <div>{text.replace(/\//g, "-")}</div>
        </div>
      ),
    },
        {
          key: "eventDuration",
          title: "Timing",
          render: (text, record) => (
            <div className="bg-violet-50 mx-auto flex items-center justify-center gap-2 text-xs border border-violet-500 rounded-full p-1 w-max text-center">
              <RiTimerLine className="text-violet-500" />
              <div>{record?.eventDuration}</div>
            </div>
          ),
        },
        {
          key: "assignee",
          title: "Assignee",
          render: (text) => <div className="text-center">{text?.name}</div>,
        },
        {
          key: "status",
          title: "Status",
          render: (text) => (
            <div
              className={`text-xs px-3 py-1 capitalize rounded-full w-max mx-auto font-semibold ${
                text === "PENDING" ? "bg-yellow-50 text-yellow-700 border border-yellow-400" :  text === "COMPLETED"
                  ? "bg-green-50 text-green-700 border border-green-400"
                  : "bg-red-50 text-red-700 border border-red-400"
              }`}
            >
              {text === "PENDING" ? "Up Coming" : text === "COMPLETED" ? "Completed" : "Not yet Completed"}
            </div>
          ),
        },
  
    {
      key: "Action",
      title: "Action",
        render: (_, record) => (
              <div className="flex justify-center items-center gap-4 text-blue-500 text-lg font-semibold">
                <BiEdit
                  className="cursor-pointer"
                  onClick={() => handleExitingData(record)}

                
                />
                <TbReplace
                  className="cursor-pointer"
                  onClick={() => {
                    setIsListModelOpen(record);
                    setSelectedMeeting(record);
                    setSelectedId(record?.assignee?.id);
                   
                  }}
                  aria-label="Edit meeting"
                />
                <RiHistoryLine
                  className="cursor-pointer"
                  onClick={() => {
                    setVisibleHistory(record);
                    setMeetingId(record.id);
                    console.log("Edit meeting:", record);
                  }}
                  aria-label="History meeting"
                />
              </div>
            ),
    },
  ];

  const handleSearchChange = (e) => {
    setSearchKey(e.target.value);
  };
  const handleClose = () => {
    setOpenStatus(false);
  };


  const handlePresonList = async () => {
    try {
      const response = await handleGetRoleBasedUsers("");
      console.log(response)
      setPresonData(response);
    } catch (error) {
      console.error("Error fetching person list:", error);
    
    }
  };

  useEffect(()=>{
    handlePresonList();
  },[])

  return (
    <div>
       {loading2 &&(
          <Loading/>
        )}
      <AnimatedContent>
       
        <div className="flex items-center justify-between mb-5">
       
          <PageTitle title="Events " />
          <div className="flex items-center gap-3">
            <CustomSearch
              handleSearchChange={handleSearchChange}
              handleSearchSubmit={handleSearchSubmit}
              placeholder="Search by heading"
            />
            <Button
              className="bg-primary rounded-[10px] w-[131px] h-[50px] text-white px-3"
              onClick={handleToggle}
            >
              Create
            </Button>
          </div>
        </div>
        <EventTable
          columns={columns}
          loading={loading}
          data={user}
          limit={limit}
          currentPage={currentPage}
          nextId={nextId}
          prevId={prevId}
          handlePageChange={handlePageChange}
          handlePageSize={handlePageSize}
          hasMore={hasMore}
        />
      </AnimatedContent>
      <Drawer open={visible} onClose={() => {
        setVisible(false);
        setExiting(false)
        setSelectedAssistant(null)

      }} title="Events Info">
        <EventForm
          register={register}
          loading={loading}
          exiting={exiting}
          presonList={presonData}
          errors={errors}
          watch={watch}
          handleSubmit={handleSubmit}
          onSubmit={handleUserManage}
          handleStatus={handleStatus}
          setSelectedAssistant={setSelectedAssistant}
  selectedAssistant={selectedAssistant}
        />
      </Drawer>
      <Model
        show={openStatus}
        userResignCount={userResignCount}
        close={()=>{
          setVisible(false);
          setOpenStatus(false);
        }}
        title={"Are you sure you want to deactivate this user?"}
        message={
          userResignCount > 0
            ? `Resign personal ${userResignCount} first, then deactivate the user.`
            : "Are you sure you want to deactivate this user?"
        }
        userDeactiveHandle={
          userResignCount > 0 ? handleClose : handleDeactiveUser
        }
      />

<Drawer
        open={visibleHistory}
        isBack={true}
        title="History Info"
        onClose={() => {
          setVisibleHistory(false);
        }}
      >
        <EventHistory meeting={selectedMeeting} eventId={meetingId} />
      </Drawer>

      <ListModel
        open={isListModelOpen}
        selectedId={selectedId}
        meetingId={selectedMeeting?.id}
        setSelectedId={setSelectedId}
        onSubmit={handleReassign}
        data={presonList}
        onClose={() => setIsListModelOpen(false)}
      />
    </div>
  );
};

export default EventList;
